import VisitorsAgreement from './VisitorsAgreement';
export default VisitorsAgreement;